var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{staticClass:"gas-status-tag",attrs:{"type":_vm.meta.type,"size":_vm.size,"effect":_vm.effect}},[_vm._v(" "+_vm._s(_vm.meta.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }